<ng-container *ngIf="(exerciceList && exerciceList.length > 0 && !filterSearchGroup.get('title').value) || taskSheetToDo && taskSheetToDo.length > 0">
    <div id="assigned-list" *ngIf="formation">
        <div class="sheetslist-title"><span translate>Exercices assigned to this formation:</span></div>

        <div class="sheetlist-wrapper">
            <div class="sheetlist-row" *ngFor="let task of taskSheetToDo">
                <div class="sheetlist-subwrap">
                    <div class="sheet-icon"
                        [ngClass]="{'sheet-validated': task.what.is_validate_by_student==true, 'sheet-todo': task.what.is_todo_by_student==true}">
                    </div>
                    <span class="sheet-title">{{ task.what.title }}</span>
                    <button class="seesheet-btn seesheet-btn-desktop"
                        (click)="emitViewEmitter(task.what, 'desktop')"></button>
                    <button class="seesheet-btn seesheet-btn-mobile"
                        (click)="emitViewEmitter(task.what, 'mobile')"></button>
                </div>
                <button class="deletesheet-btn" (click)="deleteTask(task)"></button>
            </div>
        </div>
    </div>
    <div id="available-list">
        <div class="sheetslist-title"><span translate>Available exercices:</span> </div>
        <div>
            <div class="assign-filter-wrap" [formGroup]="filterSearchGroup">
                <input class="assign-filter-field" type="text" id='search' formControlName="title"
                    placeholder="Rechercher par nom">
            </div>
        </div>
        <div class="filter-and-list-wrap">
            <div class="sheetlist-wrapper">

                <div *ngFor="let exercice of exerciceList">
                    <div class="sheetlist-row">
                        <div class="sheetlist-subwrap">
                            <span class="sheet-title">{{ exercice.title }}</span>
                            <button class="seesheet-btn seesheet-btn-desktop"
                                (click)="emitViewEmitter(exercice, 'desktop')"></button>
                            <button class="seesheet-btn seesheet-btn-mobile"
                                (click)="emitViewEmitter(exercice, 'mobile')"></button>
                        </div>
                        <button class="addsheet-btn" (click)="assignSheetToClass(exercice)" *ngIf="formation"></button>
                    </div>
                </div>
                <div *ngIf="nextPage>1"><a (click)="getAvailableSheet()" class="showmore-btn"
                        translate>sheet-assign.loadMore</a></div>
            </div>
        </div>
    </div>
</ng-container>